<template>
	<section class="content">
			<div class="divider"></div>
			<div class="info-content single-content">
				<div class="textbox-bounds  textbox-bounds-unbound-double">
					<div class="textbox textbox-right">
						<div class="textbox-tab-mark""></div>
						<div class="textbox-text">
							<div class="text-box-paragraph">
							<div class="auditionLogo">
								<img src="images/logo.png" alt="החצר" class="fillImg" >
								<div class="auditionLogoSubtitle">הרכבים</div>
							</div>
								<h3>נעים להכיר!</h3>
								<p
								שלחנו למייל שלך קצת פרטים עלינו ודברים לראות. ניצור קשר ממש בקרוב.
								</p>
								<h3>רוצים לדבר?</h3>
								<p>
								<b>אנחנו כאן בשבילכם.</b>
								</br>
								<b>במייל:</b>
								<a href="mailto:OFFICE@YARDBANDS.COM" style="cursor:pointer;color:#c7b7a5;text-decoration: underline;">office@yardbands.com</a>
								</br>
								<b>טלפון:</b>
								 054-7737094. אם לא עונים - השאירו הודעת ווצאפ ונחזור אליכם בהקדם.

								</p>
								<h3>נתראה בקרוב</h3>
							</div>
							<a href="http://yardbands.com"><label class="login-next-button">חזרה למסך הראשי</label></a>
						</div>
					</div>
				</div>
			</div>
		</section>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'
  import axios from 'axios'
  var APIbase = "https://yard-bands.herokuapp.com"
  import page from 'page'
  import VueScrollTo from 'vue-scrollto'
  export default {
    components: {
      MainLayout
    },
	created () {
		try{
			fbq('track', 'Lead');
		}catch(err){
			console.log(err)
		}
		try{			
			gtag_report_conversion(window.location.href);
		}catch(err){}
	},
	destroyed(){
		window.removeEventListener('resize',this.windowResized);
	},
	data() {
		return {
			userName : '',
			instrument : '',
			auditionType : '',
			deal_id : '',
			hour : '',
			day : '',
			email : '',
			audition_instructions: ''		
		}
	},
	methods: {
		scrollToHome() {
			window.location.href='http://dev.backyardbands.co.il'
		}
	}

  }
</script>



// WEBPACK FOOTER //
// DetailsRhythm.vue?a40c7a3e